import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './App.css';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import Profile from './components/Profile';
import TeacherDashboard from './components/TeacherDashboard';
import { isAuthenticated } from './utils/auth';
import { FuriganaProvider } from './contexts/FuriganaContext';

// Private Route wrapper component
function PrivateRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
}

function App() {
  const { t, i18n } = useTranslation();
  // Keep the browser-tab title AND the document language localized. The static
  // index.html ships title="Graph Tutor AI" + <html lang="ja">; this effect
  // re-localizes both on mount and on every language change, so EN mode does not
  // expose the page as Japanese to browsers / assistive technology.
  useEffect(() => {
    document.title = t('common.documentTitle');
    document.documentElement.lang = i18n.resolvedLanguage || i18n.language || 'ja';
  }, [t, i18n.language, i18n.resolvedLanguage]);

  return (
    <FuriganaProvider>
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/teacher/workspace"
          element={<Navigate to="/dashboard" replace />}
        />
        <Route
          path="/teacher/dashboard"
          element={
            <PrivateRoute>
              <TeacherDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/teacher"
          element={<Navigate to="/dashboard" replace />}
        />

        {/* Default redirect */}
        <Route
          path="/"
          element={
            isAuthenticated()
              ? <Navigate to="/dashboard" replace />
              : <Navigate to="/login" replace />
          }
        />

        {/* 404 - redirect to appropriate page */}
        <Route
          path="*"
          element={
            isAuthenticated()
              ? <Navigate to="/dashboard" replace />
              : <Navigate to="/login" replace />
          }
        />
      </Routes>
    </BrowserRouter>
    </FuriganaProvider>
  );
}

export default App;